<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="back" v-if="isShow">
        <i class="el-icon-back" @click="back"></i>
      </div>
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">加班基本信息</span>
      </div>
      <div>
        <dynamic-form
          ref="form"
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="!isShow"
          :showSaveBtn="!isShow"
          v-loading="initloading"
          :disabled="isShow"
          @save="save(1)"
          @submit="submit(2)"
          @cancelForm="cancel"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import "@/components/dynamic-form";
import { addAbsence, editAbsence, getAbsenceInfoById } from "@/api/absence";
import { deepClone } from "@/utils/index";
export default {
  data() {
    var validateLeaveDays = (rule, value, callback) => {
      if (this.form.leaveType === "调休") {
        if (value > this.paidLeaveDays) {
          callback(new Error("调休时长不能大于调休剩余天数"));
        }
      }
      if (value === "") {
        callback(new Error("请假时长不能为空"));
      } else {
        callback();
      }
    };
    return {
      paidLeaveDays: 0,
      initloading: false,
      loading: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "项目号",
            key: "projectNumber",
            type: "databox",
            span: 8,
            props: {
              label: "id",
              value: ""
            },
            url: "/bsProject",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "databox",
            // type: "input",
            key: "leavePeople",
            label: "请假人",
            value: "",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "工号",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "姓名",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [
              {
                required: true,
                message: "请输入请假人",
                trigger: "change"
              }
            ]
          },
          {
            type: "select",
            key: "leaveType",
            label: "请假类型",
            value: "",
            span: 8,
            placeholder: "请选择请假类型",
            options: [
              { value: "事假", label: "事假" },
              { value: "病假", label: "病假" },
              { value: "调休", label: `调休(还剩${this.paidLeaveDays}天)` }
            ],
            rules: [
              {
                required: true,
                message: "请假类型不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "databox",
            key: "proposer",
            label: "申请人",
            value: "",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "工号",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "姓名",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [
              {
                required: true,
                message: "请输入申请人",
                trigger: "change"
              }
            ]
          },
          {
            type: "date",
            subtype: "datetime",
            key: "beginTime",
            label: "开始时间",
            value: "",
            span: 8,
            placeholder: "请选择计划日期",
            rules: [
              {
                required: true,
                message: "开始时间不能为空",
                trigger: "change"
              }
            ]
          },
          {
            type: "date",
            subtype: "datetime",
            key: "endTime",
            label: "结束时间",
            value: "",
            span: 8,
            placeholder: "请选择计划日期",
            rules: [
              {
                required: true,
                message: "结束时间不能为空",
                trigger: "change"
              }
            ]
          },
          {
            type: "input",
            key: "leaveDays",
            label: "请假时长",
            value: "",
            span: 8,
            // disabled: true
            rules: [{ validator: validateLeaveDays, trigger: "blur" }]
          },
          {
            type: "textarea",
            key: "leaveMatter",
            label: "请假事由",
            value: "",
            span: 16,
            placeholder: "请输入请假事由",
            rules: [
              { required: true, message: "请假事由不能为空", trigger: "blur" }
            ]
          }
          // {
          //   type: "textarea",
          //   key: "remark",
          //   label: "备注",
          //   value: "",
          //   placeholder: "请输入备注",
          //   span: 16
          // }
        ]
      }
    };
  },
  computed: {
    isShow() {
      console.log(this.$route.query);
      if (this.$route.query && this.$route.query.isShow) {
        return this.$route.query.isShow;
      } else {
        return false;
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      if (!this.$route.query.id) {
        return;
      }
      this.initloading = true;
      try {
        const result = await getAbsenceInfoById(this.$route.query.id);
        console.log(result);
        const form = result.data;
        this.paidLeaveDays = form.paidLeaveDays || 0;
        form.projectNumber = { id: form.projectNumber };
        form.proposer = { name: form.proposer };
        form.leavePeople = { name: form.leavePeople };
        const index = this.formConfig.formItemList.findIndex(
          item => item.key === "leaveType"
        );
        this.formConfig.formItemList[index].options = [
          { value: "事假", label: "事假" },
          { value: "病假", label: "病假" },
          { value: "调休", label: `调休(还剩${form.paidLeaveDays || 0}天)` }
        ];
        this.form = form;
        this.initloading = false;
      } catch (e) {
        this.initloading = false;
      }
    },
    submit(status) {
      this.pull(status);
    },
    save(status) {
      this.pull(status);
    },
    pull(status) {
      this.$refs["form"].validate().then(() => {
        const data = deepClone(this.form);
        data.beginTime = new Date(this.form.beginTime).getTime();
        data.endTime = new Date(this.form.endTime).getTime();
        if (data.projectNumber) {
          data.projectNumber = data.projectNumber.id;
        }
        if (data.proposer) {
          data.proposer = data.proposer.name;
        }
        if (data.leavePeople) {
          data.leavePeople = data.leavePeople.name;
        }
        data.approvalStatus = status;
        if (this.form.id) {
          this.doEdit(data);
        } else this.doAdd(data);
        this.cancel();
      });
    },
    doAdd(data) {
      this.loading = true;
      addAbsence(data)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit(data) {
      this.loading = true;
      editAbsence(data)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err.response.data.message);
        });
    },
    cancel() {
      this.$router.push("/absence");
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
</style>